import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import RequestAccess from '../views/RequestAccess.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import Dashboard from '../views/Dashboard.vue'
import AdminManagement from '../views/AdminManagement.vue'
import TicketBoard from '../views/TicketBoard.vue'
import TicketDetail from '../views/TicketDetail.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/request-access',
      name: 'request-access',
      component: RequestAccess
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/manage',
      name: 'admin-management',
      component: AdminManagement,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/board',
      name: 'board',
      component: TicketBoard,
      meta: { requiresAuth: true }
    },
    {
      path: '/ticket/:id',
      name: 'ticket-detail',
      component: TicketDetail,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  
  if (to.name === 'login' && token) {
    next({ name: 'dashboard' })
  } else if (to.meta.requiresAuth && !token) {
    next({ name: 'login' })
  } else if (to.meta.requiresAdmin && user.role !== 'ADMIN') {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
